import { render } from "./DialogSupporto.vue?vue&type=template&id=5b32e514"
import script from "./DialogSupporto.vue?vue&type=script&lang=js"
export * from "./DialogSupporto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__